import {
  CabinContentsProductDetailsFormValues,
  CabinContentsProductPriceFormValues,
} from "Features/CheckPrice/Products/RiskProducts/HouseProducts/CabinContents/cabinContentsInterfaces";

import { NotSuperReasonCabinContents } from "Features/CheckPrice/Products/RiskProducts/HouseProducts/CabinContents/cabinContentsTypes";
import { CabinContentsCoverage } from "Store/interfaces/products/coverage";
import { formBooleanToBoolean } from "Utils/formUtils";
import { isDefined } from "Utils/functions";

export const findNotSuperReason = (
  formValuesDetails?: CabinContentsProductDetailsFormValues,
): NotSuperReasonCabinContents | null => {
  if (
    isDefined(formValuesDetails) &&
    formBooleanToBoolean(formValuesDetails.hasRental)
  ) {
    return NotSuperReasonCabinContents.HAS_RENTAL;
  }

  return null;
};

export const getInitialFormStateWithCorrectCoverage = (
  formState: Partial<CabinContentsProductPriceFormValues>,
  standardOnly: boolean,
): CabinContentsProductPriceFormValues =>
  <CabinContentsProductPriceFormValues>{
    ...formState,
    coverage: standardOnly
      ? CabinContentsCoverage.CABIN_CONTENTS_STANDARD
      : formState.coverage,
  };
